import { render, staticRenderFns } from "./PersonalDetailsTravel.vue?vue&type=template&id=10b9a277"
import script from "./PersonalDetailsTravel.vue?vue&type=script&lang=js"
export * from "./PersonalDetailsTravel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports